export default __webpack_public_path__ + "d10a5642ac72633bf03a452afe88de5a.png";